<template>
    <div class="point-content">
        <div class="sheet-top">
            <div class="sheet-title">点位选择</div>
            <div class="sheet-close" @click="closepoint">
                <img src="@/assets/sheet-close.png" class="sheet-close-img" alt="">
            </div>
        </div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"
            class="sec-all">全选</el-checkbox>
        <div class="point-cont">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="point in pointlist" :label="point.sn" :key="point.sn">{{ point.sn }}</el-checkbox>
            </el-checkbox-group>
        </div>
        <div class="point-foot">
            <el-button type="primary" @click="pointConfirm" size="small">确认提交</el-button>
            <el-button type="info" @click="closepoint" size="small">取消</el-button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    props: {
        vdata: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            pointlist: [],
            showpointlist: false,
            checkAll: false,
            isIndeterminate: true,
            checkedCities: []
        }
    },
    methods: {
        getmapPint() {
            let config = {
                url: 'https://bi.17886.cn/api/tuling/get_latest_coordinates.php',
                methods: 'get'
            }
            axios(config).then(res => {
                this.pointlist = res.data.data
                this.checkedCities = this.vdata.map(item => item.sn)
            })
        },
        openpoint() {
            this.showpointlist = true
        },
        closepoint() {
            this.$emit('closepoint')
            // this.showpointlist = false
        },
        handleCheckAllChange(val) {
            this.checkedCities = val ? this.pointlist.map(item => item.sn) : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length
            this.checkAll = checkedCount == this.pointlist.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.pointlist.length;
        },
        pointConfirm() {
            let slist = []
            if (this.checkedCities.length == 0) {

            } else {
                slist = this.checkedCities.map(item => {
                    return this.pointlist.find(del => del.sn == item)
                })
            }
            this.$emit('pointconfirm', slist)
        }
    },
    mounted() {
        this.getmapPint()
    }
}
</script>

<style scoped lang="scss">
.sheet-top {
    width: 100%;
    height: 54px;
    background: #F1F3F4;
    display: flex;
    align-items: center;
}

.sec-all {
    margin: 24px 0 16px 24px;
}

.sheet-title {
    margin-left: 36px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #1E1E1E;
    line-height: 23px;
}

.sheet-close {
    margin: -12px 32px 0 auto;
    height: 12px;
    width: 12px;

    .sheet-close-img {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}

.point-cont {
    padding: 0 24px 24px;
    box-sizing: border-box;
    line-height: 2;
}

.point-foot {
    padding: 24px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
}
</style>